import { render } from "./PasswordResetRequestScreen.vue?vue&type=template&id=33ad1794&scoped=true&ts=true&lang=pug"
import script from "./PasswordResetRequestScreen.vue?vue&type=script&lang=ts"
export * from "./PasswordResetRequestScreen.vue?vue&type=script&lang=ts"

import "./PasswordResetRequestScreen.vue?vue&type=style&index=0&id=33ad1794&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ad1794"]])

export default __exports__